import React from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
/*import Header from './components/Header';*/
import ProfileSection from './components/ProfileSection';
import ExperienceSection from './components/ExperienceSection';
import SkillsSection from './components/SkillsSection';
import EducationSection from './components/EducationSection';
import './styles/App.css';

const App = () => (
  <div className="App">
    <Navbar />
    <HeroSection />
    { /*<Header />*/ }
    <ProfileSection />
    <ExperienceSection />
    <SkillsSection />
    <EducationSection />
  </div>
);
export default App;
